module.exports = __webpack_public_path__ + "static/media/3. B14, Superficie sólida, 31 x 58 x 32cm, 2020 copy.08264176.png";